const serviceToReceipt = `mutation{servicesToReceipts}`;

export default serviceToReceipt;
